export default __webpack_public_path__ + "static/media/java.198ca826.png";